import { smoother } from "../../base/_gsap-core.js";
import {
   Carousel,
   Autoplay,
   Thumbs,
} from '../../base/_fancyapps.js';

export function initCarouselClients() {
   const carouselEls = document.querySelectorAll('.carousel-client .carousel');

   if (carouselEls.length) {
      carouselEls.forEach((carouselEl) => {
         new Carousel(carouselEl, {
            Autoplay: {
               timeout: 5000,
               autoStart: false,
            },
            Dots: {
               dynamicFrom: 5,
               minCount: 3,
            },
            Navigation: false,
            center: false,
            transition: 'slide',
            infinite: false,
         }, { Autoplay });
      });
   }
}
